import { useState } from 'react'

import { Box, Center, Spinner, Text } from '@chakra-ui/react'

import Modal from '../modal'
import StyledTextarea from '../styled/text-area'
import { StarPicker } from './stars'

import { useRanContext } from '../ran-state-provider'
import { rateVerifiedService } from '../../lib/api-helper'

const REVIEW_MAX = 500

// The caller is responsible for only opening this for a signed in player.
const RatingModal = ({ member, myRating, onClose, onRated, setToast }) => {
  const { setAuthentication } = useRanContext()

  const [isLoading, setLoading] = useState(false)
  const [score, setScore] = useState(myRating?.score || 0)
  const [review, setReview] = useState(myRating?.review || '')

  const handleSubmit = async () => {
    if (isLoading) return

    if (score < 1 || score > 5) {
      setToast({
        status: 'error',
        messages: ['Pick a score from 1 to 5 stars.']
      })
      return
    }

    setLoading(true)

    const result = await rateVerifiedService(
      {
        communityMemberId: member.id,
        score,
        review
      },
      setAuthentication
    )

    if (result?.success) {
      setToast({
        status: 'success',
        messages: [`Your rating for ${member.name} has been saved.`]
      })
      onRated(result.data)
      onClose()
      return
    }

    setToast({
      status: 'error',
      messages: result?.errors?.length ? result.errors : ['Something went wrong']
    })
    setLoading(false)
  }

  return (
    <Modal
      header={`RATE ${(member.name || '').toUpperCase()}`}
      isOpen={true}
      isLoading={isLoading}
      onClose={() => onClose()}
      onSubmit={handleSubmit}
      submitText={myRating ? 'UPDATE' : 'SUBMIT'}
    >
      {isLoading ? (
        <Center>
          <Spinner />
        </Center>
      ) : (
        <Box align="center" w="full">
          <Text mb={2}>
            How was your transaction with <b>{member.name}</b>?
          </Text>

          <StarPicker value={score} onChange={setScore} />

          <Text fontSize={12} opacity={0.6} mb={4}>
            {score > 0 ? `${score} of 5 stars` : 'Tap a star to score'}
          </Text>

          <StyledTextarea
            value={review}
            maxLength={REVIEW_MAX}
            onChange={e => setReview(e.target.value)}
            placeholder="REVIEW (OPTIONAL)"
            rows={4}
          />

          <Text fontSize={11} opacity={0.5} mt={1} align="right">
            {review.length}/{REVIEW_MAX}
          </Text>

          <Text fontSize={12} opacity={0.6} mt={3}>
            You can only leave one rating per member. Rating again replaces
            your previous one.
          </Text>
        </Box>
      )}
    </Modal>
  )
}

export default RatingModal
